function contentCarousel() {
  return {
    scrollPosition: 0,
    isDragging: false,
    startX: 0,
    scrollLeft: 0,
    
    init() {
      // Check if carousel exists
      const carousel = this.$el.querySelector('.content-carousel__carousel');
      if (!carousel) return;
      
      // Make carousel scrollable if content overflows
      const track = carousel.querySelector('.carousel-track');
      if (track && track.scrollWidth > carousel.clientWidth) {
        // Enable horizontal scrolling
        carousel.style.overflowX = 'auto';
        
        // Add smooth scrolling
        carousel.style.scrollBehavior = 'smooth';
        
        // Optional: Add mouse drag functionality
        carousel.addEventListener('mousedown', (e) => this.startDrag(e));
        carousel.addEventListener('mouseleave', () => this.stopDrag());
        carousel.addEventListener('mouseup', () => this.stopDrag());
        carousel.addEventListener('mousemove', (e) => this.drag(e));
        
        // Prevent image drag
        const images = carousel.querySelectorAll('img');
        images.forEach(img => {
          img.addEventListener('dragstart', (e) => e.preventDefault());
        });
      }
    },
    
    startDrag(e) {
      const carousel = this.$el.querySelector('.content-carousel__carousel');
      this.isDragging = true;
      this.startX = e.pageX - carousel.offsetLeft;
      this.scrollLeft = carousel.scrollLeft;
      carousel.style.cursor = 'grabbing';
    },
    
    stopDrag() {
      this.isDragging = false;
      const carousel = this.$el.querySelector('.content-carousel__carousel');
      carousel.style.cursor = 'grab';
    },
    
    drag(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const carousel = this.$el.querySelector('.content-carousel__carousel');
      const x = e.pageX - carousel.offsetLeft;
      const walk = (x - this.startX) * 2;
      carousel.scrollLeft = this.scrollLeft - walk;
    }
  }
}